/*
 Created by CHT 2019/12/4 10:11
*/

/**
 * @param prefix
 * @returns {string}
 */
export function uuid(prefix) {
  prefix = prefix || ''
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  let uuid = []
  const len = 8
  const radix = chars.length
  for (let i = 0; i < len; i++) {
    uuid[i] = chars[0 | Math.random() * radix]
  }
  return prefix + Date.now().toString(36) + uuid.join('')
}
